/** @jsx jsx */
import { Box, Flex, ModalContainer, ModalContent } from "@eworkit/iris";
import { FC } from "react";
import { createPortal } from "react-dom";
import { jsx } from "theme-ui";

import { PublicAnchor } from "@/router/PublicAnchor";
import { EworkLogo } from "@/views/components/Logo";

interface AnimatedLayoutModalProps {
  size?: "sm" | "md";
}

export const AnimatedLayoutModal: FC<AnimatedLayoutModalProps> = ({ size = "md", children }) => {
  return createPortal(
    <div
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        maxWidth: size === "sm" ? [null, null, 468] : [null, null, 560],
        marginX: "auto",
      }}>
      <ModalContainer>
        <ModalContent
          sx={{
            "&[data-component='dialog-content']": {
              pl: 0,
              pr: 0,
            },
          }}>
          <Box py="xxl">
            <Flex flexDirection="column" gap="md">
              <Flex justifyContent="center">
                <PublicAnchor page="">
                  <EworkLogo size="xxl" orientation="landscape" />
                </PublicAnchor>
              </Flex>

              <Box>{children}</Box>
            </Flex>
          </Box>
        </ModalContent>
      </ModalContainer>
    </div>,
    document.body,
  );
};
